import React, { useEffect, useState } from 'react';
import myinvoisConfigService from '../../../services/myinvois/myinvois_config.service';
import WhatToDoNextMyInvois from './what_to_do_next myinvois';
import WhatToDoNext from './what_to_do_next';
import { Col, Row, Skeleton } from 'antd';
import globalHelper from '../../../helpers/functions/global.helper';

const WhatToDoWrapper = ({ ticket, }) => {
    const [state, setState] = useState({
        loading : false,
        myinvois_park_config : null,
    })

    const checkMyInvoisParkConfig = async () => {
        setState(state => ({...state, loading : true, }));
        const myInvoisConfigParkResponse = await myinvoisConfigService?.fetchMyInvoisConfigPark(ticket?.park_id);

        const { myinvois_park_config, } = myInvoisConfigParkResponse;
        setTimeout(() => {
            setState(state => ({...state, loading : false, myinvois_park_config, }));
        }, 500);
        
    }

    useEffect(() => {
        checkMyInvoisParkConfig();
    }, [ticket])

    return (
        <>
            {
                state?.loading ?
                (
                    <>
                        <Row justify={'center'}>
                            <Col xs={24} lg={20} span={20}>
                                <Loader />
                            </Col>
                        </Row>
                        
                    </>
                )
                :
                (
                    <>
                        {
                            // if myinvois is configured
                            state?.myinvois_park_config ?
                            (
                                <>
                                    <WhatToDoNextMyInvois ticket={ticket} />
                                </>
                            )
                            :
                            (
                                <>
                                    <WhatToDoNext ticket={ticket} />
                                </>
                            )
                        }
                    </>
                )
            }
        </>
    );
}

const Loader = () => {
    return (
        <>
            <Row gutter={[20, 20]}>
                <Col xs={24} md={14} lg={14}>
                    <Skeleton.Button block style={{ width : '100%', height : globalHelper?.isMobileScreen() ? 140 : 240, background : 'var(--secondary-button-color)', }} />
                </Col>
                <Col xs={24} md={10} lg={10}>
                    <Skeleton.Button block style={{ width : '100%', height : globalHelper?.isMobileScreen() ? 140 : 240, background : 'var(--secondary-button-color)', }} />
                </Col>
            </Row>
            
        </>
    );
}

export default WhatToDoWrapper;